import Cookies from 'js-cookie'

const state = localStorage.getItem('token_id')
export const initialCookie = state ? JSON.parse(state) : {}
